var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7H2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5H12V21.25H13.5V10.5L20.6325 12.5442C21.4491 12.8164 22 13.5807 22 14.4415V21.25C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25V8.5H3V19C3 19.4142 3.33579 19.75 3.75 19.75C4.16421 19.75 4.5 19.4142 4.5 19V18.75H7V19C7 19.4142 7.33579 19.75 7.75 19.75C8.16421 19.75 8.5 19.4142 8.5 19V8.5ZM18 14C17.4477 14 17 14.4477 17 15V16C17 16.5523 17.4477 17 18 17H19C19.5523 17 20 16.5523 20 16V15C20 14.4477 19.5523 14 19 14H18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.25H7V15.75H4.5V17.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.25H4.5V12.75H7V14.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.25H7V9.75H4.5V11.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilo);
export default __webpack_public_path__ + "static/media/silo.1a9fdafa7206a834289b6ddab25f1bed.svg";
export { ForwardRef as ReactComponent };